import { render, staticRenderFns } from "./MemberImageCard.vue?vue&type=template&id=884e5e46&scoped=true"
import script from "./MemberImageCard.vue?vue&type=script&lang=ts"
export * from "./MemberImageCard.vue?vue&type=script&lang=ts"
import style0 from "./MemberImageCard.vue?vue&type=style&index=0&id=884e5e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884e5e46",
  null
  
)

export default component.exports